<template>
  <ul
    v-show="totalPages"
    class="flex list-reset border border-grey-light rounded w-auto font-sans"
  >
    <li>
      <a
        class="block bg-blue-light text-white hover:text-white hover:bg-blue text-blue border-r border-grey-light px-3 py-2"
        href="#"
        :disabled="previousPageDisabled"
        @click.prevent="previousPage"
        v-text="'Previous'"
      />
    </li>
    <li
      v-for="page in pages"
      :key="page"
    >
      <a
        class="block hover:text-white hover:bg-blue border-r border-grey-light px-3 py-2"
        :class="[isCurrentPage(page) ? 'bg-blue text-white' : 'bg-blue-light text-blue']"
        href="#"
        @click.prevent="goToPage(page)"
        v-text="page"
      />
    </li>
    <li>
      <a
        class="block bg-blue-light text-blue hover:text-white hover:bg-blue px-3 py-2"
        href="#"
        :disabled="nextPageDisabled"
        @click.prevent="nextPage"
        v-text="'Next'"
      />
    </li>
  </ul>
</template>

<script type="text/babel">
export default {
  name: 'CommPagination',
  props: {
    pagination: {
      type: Object,
      required: true,
    },
  },
  computed: {
    totalPages() {
      return this.pagination.total_pages
    },
    currentPage() {
      return this.pagination.current_page
    },
    nextPageDisabled() {
      return this.currentPage + 1 > this.totalPages
    },
    previousPageDisabled() {
      return this.currentPage - 1 < 1
    },
    pages() {
      let i = 0
      const pages = []

      do {
        i = i + 1

        pages.push(i)
      } while (i < this.totalPages)

      return pages
    },
  },
  methods: {
    changePage(page) {
      const url = window.location.href

      if (url.indexOf('?') === -1 || url.indexOf('page=') === -1) {
        window.location.href = `${url}?page=${page}`
      } else {
        window.location.href = url.replace(/(page=)\d+/g, `page=${page}`)
      }
    },
    previousPage() {
      if (!this.previousPageDisabled) {
        this.changePage(this.currentPage - 1)
      }
    },
    nextPage() {
      if (!this.nextPageDisabled) {
        this.changePage(this.currentPage + 1)
      }
    },
    goToPage(page) {
      if (!this.isCurrentPage(page)) {
        this.changePage(page)
      }
    },
    isCurrentPage(page) {
      return page == this.currentPage
    },
  },
}
</script>
